exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2dWkkMPwLv5_MWymls4b_A{background:#fff;font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;z-index:999;font-size:12px;border-radius:2px;box-shadow:0 0 0 1px rgba(0,0,0,0.1),0 1px 10px rgba(0,0,0,0.25);padding:10px 5px}._2dWkkMPwLv5_MWymls4b_A ul{list-style-type:none;margin:0 0;padding:0 0}._2dWkkMPwLv5_MWymls4b_A li{margin:0 5px;padding:0 0;display:inline-block;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"LinkEditToolbar": "_2dWkkMPwLv5_MWymls4b_A"
};